import { toast } from '@/components/ToastNotification'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select'
import { api } from '@/lib/api'
import { useState } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { CriarPacienteFormData } from '../schemas/paciente.schema'

interface AbaConfiguracoesProps {
  form: UseFormReturn<CriarPacienteFormData>
  formData: CriarPacienteFormData
  temUsuario?: boolean
  pacienteId?: number
  onUsuarioCriado?: () => void
}

export const AbaConfiguracoes = ({
  form,
  formData,
  temUsuario = false,
  pacienteId,
  onUsuarioCriado
}: AbaConfiguracoesProps) => {
  const [criandoUsuario, setCriandoUsuario] = useState(false)
  const [usuarioCriadoLocal, setUsuarioCriadoLocal] = useState(false)
  const mostrarBotaoCriarUsuario =
    !!pacienteId && !temUsuario && !usuarioCriadoLocal

  // Converte boolean para string para exibição no Select
  const statusExibicao = formData.status ? 'ATIVO' : 'INATIVO'

  // Converte string do Select para boolean
  const handleStatusChange = (value: string) => {
    const novoStatus = value === 'ATIVO'
    form.setValue('status', novoStatus)
  }

  const handleCriarUsuario = async () => {
    if (!pacienteId) return
    setCriandoUsuario(true)
    try {
      await api.post(`/api/paciente/${pacienteId}/criar-usuario`)
      toast.success('Usuário de acesso criado com sucesso.')
      setUsuarioCriadoLocal(true)
      onUsuarioCriado?.()
    } catch (error: any) {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        'Erro ao criar usuário para o paciente.'
      toast.error(msg)
    } finally {
      setCriandoUsuario(false)
    }
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Configurações do Paciente</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="status">Status</Label>
          <Select value={statusExibicao} onValueChange={handleStatusChange}>
            <SelectTrigger>
              <SelectValue placeholder="Selecione o status" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="ATIVO">Ativo</SelectItem>
              <SelectItem value="INATIVO">Inativo</SelectItem>
            </SelectContent>
          </Select>
        </div>
        {mostrarBotaoCriarUsuario && (
          <div className="space-y-2 mr-7">
            <Label className="mr-5">Acesso ao portal</Label>
            <Button
              type="button"
              variant="secondary"
              onClick={handleCriarUsuario}
              disabled={criandoUsuario}
            >
              {criandoUsuario ? 'Criando...' : 'Criar usuário para acesso'}
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  )
}
